import { createAction, props } from '@ngrx/store';
import {
  AccountCookie,
  DashboardResponse
} from '../../models/login-dashboard.interfaces';

enum LoginDashboardActionTypes {
  storeLoginDashboardInputValues = '[flight-shop book widget] login dashboard store input values',
  loadDashboardLanding = '[flight-shop book widget] load dashboard api',
  loadDashboardLandingSuccess = '[flight-shop book widget] load dashboard api success',
  loadDashboardLandingFailure = '[flight-shop book widget] load dashboard api failure'
}

export const StoreLoginDashboardInputValues = createAction(
  LoginDashboardActionTypes.storeLoginDashboardInputValues,
  props<{
    accountCookieValue: AccountCookie | null;
    isHipmunk: boolean;
  }>()
);

export const LoadDashboardLanding = createAction(
  LoginDashboardActionTypes.loadDashboardLanding
);

export const LoadDashboardLandingSuccess = createAction(
  LoginDashboardActionTypes.loadDashboardLandingSuccess,
  props<{
    dashboardResponse: DashboardResponse;
  }>()
);

export const LoadDashboardLandingFailure = createAction(
  LoginDashboardActionTypes.loadDashboardLandingFailure
);
